import { Link } from "react-router-dom";

// What the customer asked to cancel, from the ticket detail's customer_request
// (helpers/customerCancellationRequest.helper.js on the server). A whole-trip,
// all-passenger request used to show the agent nothing at all: "all passengers"
// stores no passenger ids, and "whole trip" on split legs is one ticket per leg.
// sameTicketView: both flights are already on this page (Whole Trip shown as one
// ticket), so the "other flight is on a separate ticket" note is left out.
export default function CustomerRequestCard({ request, sameTicketView = false }) {
  if (!request) return null;
  const {
    source,
    scope,
    scope_label,
    routes = [],
    all_passengers,
    passenger_count,
    total_passengers,
    passengers = [],
    related_tickets = [],
  } = request;
  const fromChat = source === "CHATBOT";

  return (
    <div className="rounded-xl border border-blue-200 bg-blue-50 px-3 py-3 space-y-2" data-testid="customer-request">
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-bold text-blue-800 uppercase tracking-wide">
          {fromChat ? "What the customer asked for (in the app chat)" : "What the customer asked for"}
        </span>
        {scope === "WHOLE_TRIP" && (
          <span className="text-[10px] font-semibold text-blue-800 bg-blue-100 px-2 py-0.5 rounded-full">
            Whole trip
          </span>
        )}
      </div>

      <div className="text-sm text-gray-800 space-y-1">
        <div>
          <span className="text-gray-500">Cancel: </span>
          <span className="font-semibold">{scope_label}</span>
        </div>
        {routes.length > 0 && (
          <div>
            <span className="text-gray-500">Flights: </span>
            <span className="font-semibold">{routes.join("  and  ")}</span>
          </div>
        )}
        <div>
          <span className="text-gray-500">Passengers: </span>
          <span className="font-semibold">
            {all_passengers
              ? `All ${total_passengers} passenger${total_passengers === 1 ? "" : "s"}`
              : `${passenger_count} of ${total_passengers} passengers`}
          </span>
        </div>
        {passengers.length > 0 && (
          <ul className="pl-4 list-disc text-gray-700">
            {passengers.map((p) => (
              <li key={p.passenger_id}>{p.name || `Passenger ${p.passenger_id}`}</li>
            ))}
          </ul>
        )}
      </div>

      {related_tickets.length > 0 && !sameTicketView && (
        <div className="border-t border-blue-100 pt-2 text-xs text-blue-900 space-y-1">
          <p>
            The other flight of this trip is on a separate ticket. Process both so the whole
            trip is cancelled as the customer asked:
          </p>
          {related_tickets.map((t) => (
            <Link
              key={t.ticket_id}
              to={`/admin/tickets/${t.ticket_id}`}
              className="block font-semibold underline hover:text-blue-700"
            >
              Ticket #{t.ticket_id}
              {t.route ? ` (${t.route})` : ""}
              {t.cancellation_status ? `, ${t.cancellation_status.replace(/_/g, " ")}` : ""}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
